import { Box } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { SystemSwitch } from "../../components/UIToolkit/Clickable/SystemSwitch";
import { InfoIconWithTooltip } from "../../components/UIToolkit/molecules/InfoIconWithTooltip";

interface AppendRoleToNameSettingProps {
	isDetailed: boolean;
	appendRoleToName: boolean;
	onAppendRoleToNameChange: (enabled: boolean) => void;
}

/** Detailed-only "Add staff role to Name" toggle, in the same switch + ⓘ form as its Additional Settings neighbours. */
export const AppendRoleToNameSetting: FC<AppendRoleToNameSettingProps> = ({ isDetailed, appendRoleToName, onAppendRoleToNameChange }) => {
	const { t } = useTranslation();
	if (!isDetailed) return null;

	return (
		<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
			<SystemSwitch
				dataTestId="printout-append-role-to-name-switch"
				checked={appendRoleToName}
				onChange={() => onAppendRoleToNameChange(!appendRoleToName)}
				label={t("printout.append.role.to.name")}
			/>
			<InfoIconWithTooltip dataTestId="printout-append-role-to-name-info" title={t("printout.append.role.to.name.description")} />
		</Box>
	);
};
